export const NOT_APPLICABLE_COLOR_DOT = "#999999";

export const NEGATIVE = "NEGATIVE";
export const NEGATIVE_COLOR = "#FCE5EC";
export const NEGATIVE_COLOR_DOT = "#e60246";

export const INTERMEDIATE = "INTERMEDIATE";
export const INTERMEDIATE_COLOR = "#FEF8E9";
export const INTERMEDIATE_COLOR_DOT = "#FFBE00";

export const POSITIVE = "POSITIVE";
export const POSITIVE_COLOR = "#E5F4EE";
export const POSITIVE_COLOR_DOT = "#009355";

export const RED_ON_RIGHT_COLOR_PALETTE = [
  NEGATIVE_COLOR,
  NEGATIVE_COLOR,
  INTERMEDIATE_COLOR,
  INTERMEDIATE_COLOR,
  POSITIVE_COLOR,
  POSITIVE_COLOR,
  INTERMEDIATE_COLOR,
  INTERMEDIATE_COLOR,
  NEGATIVE_COLOR,
  NEGATIVE_COLOR,
];

export const GREEN_ON_RIGHT_COLOR_PALETTE = [
  POSITIVE_COLOR,
  POSITIVE_COLOR,
  INTERMEDIATE_COLOR,
  INTERMEDIATE_COLOR,
  NEGATIVE_COLOR,
  NEGATIVE_COLOR,
];
